import dayjsTZ from "../../../utils/dayjs";
import { htmlParser } from "../../../utils";
import { stripHtmlToText } from "./utils/ticketStatus";

function MessageBubble({ message, isOwn }) {
  const raw = message?.body || "";
  const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
  // Keep emoji / plain text as-is; parse Quill HTML for rich content.
  let content = raw || stripHtmlToText(raw);
  if (looksLikeHtml) {
    try {
      content = htmlParser(raw);
    } catch (err) {
      console.error("MessageBubble parse failed", err);
      content = stripHtmlToText(raw) || "Mesazh me foto";
    }
  }

  return (
    <div
      className={`supportMessageBubble ${
        isOwn ? "supportMessageBubble--own" : "supportMessageBubble--peer"
      }`}
    >
      <div className="supportMessageBubble__meta">
        <span className="supportMessageBubble__author">
          {message?.authorName ||
            (message?.authorRole === "admin" ? "Support" : "Punonjësi")}
        </span>
        <span className="supportMessageBubble__time">
          {dayjsTZ(message?.createdAt).format("DD/MM/YYYY HH:mm")}
        </span>
      </div>
      <div className="supportMessageBubble__body">{content}</div>
    </div>
  );
}

export default MessageBubble;
